import * as React from 'react';
import {
    BooleanField,
    BooleanInput,
    Create,
    Edit,
    EditButton,
    List,
    NumberField,
    NumberInput,
    required,
    SimpleForm,
    TextField,
    TextInput
} from 'react-admin';
import AdminPagination from '../AdminPagination';
import AdminSelectableDatagrid from '../AdminSelectableDatagrid';
import HumanDeleteButton from '../HumanDeleteButton';
import HumanRecordTitle from '../HumanRecordTitle';

const filters = [
    <TextInput source="all" label="Recherche" alwaysOn />,
];

const parseCommunes = (value: string) =>
    typeof value === 'string'
        ? value.split('\n').map((item) => item.trim()).filter(Boolean)
        : value;

const formatCommunes = (value: string[]) =>
    Array.isArray(value) ? value.join('\n') : '';

const ZoneForm = () => (
    <>
        <TextInput source="code" label="Code" validate={required()} />
        <TextInput source="name" label="Zone" validate={required()} fullWidth />
        <TextInput
            source="communes"
            label="Communes — une par ligne"
            multiline
            rows={12}
            fullWidth
            parse={parseCommunes}
            format={formatCommunes}
        />
        <BooleanInput source="active" label="Active" defaultValue={true} />
        <NumberInput source="position" label="Position" validate={required()} />
    </>
);

export const BoxDeliveryZoneList = (props) => (
    <List
        {...props}
        filters={filters}
        bulkActionButtons={false}
        sort={{ field: 'position', order: 'ASC' }}
        perPage={50}
        pagination={<AdminPagination />}
        exporter={false}
    >
        <AdminSelectableDatagrid>
            <NumberField source="position" label="#" />
            <TextField source="code" label="Code" />
            <TextField source="name" label="Zone" />
            <BooleanField source="active" label="Active" />
            <EditButton />
            <HumanDeleteButton fields={["name"]} fallback="cette zone" />
        </AdminSelectableDatagrid>
    </List>
);

export const BoxDeliveryZoneEdit = (props) => (
    <Edit {...props} mutationMode="optimistic" title={<HumanRecordTitle fields={["name"]} fallback="Zone Box" />}>
        <SimpleForm redirect="list">
            <ZoneForm />
        </SimpleForm>
    </Edit>
);

export const BoxDeliveryZoneCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <ZoneForm />
        </SimpleForm>
    </Create>
);
